var notPracticeSport = cube.$id('notPracticeSport');
var acSportList=cube.$id('acSportList');
var $acSportList=$(acSportList);
var title = cube.$id("my-sports--title");
var lvl_0 = cube.$class("user-sports--level_0");
var lvl_1 = cube.$class("user-sports--level_1");
var html = cube.$('html');

const services = {
	DELETE_ALL_SPORT_URL : 'rest/model/atg/userprofiling/ProfileActor/create-manage-sports'
};

const createAccountModule = {
  init: function () {
  	createAccountModule.events();
  },

  events: function () {
  	cube.$id('addSportButton').addEventListener('click',createAccountModule.addSport);
  	cube.$id('backSportButton').addEventListener('click',createAccountModule.backSport);
  	notPracticeSport.addEventListener('change',createAccountModule.removeAllSportsToCustomer);
  },

  addSport: function(e){
		e.preventDefault();
		title.text = title.dataset.origin;
		html.style.overflowY = 'hidden';
		$acSportList.fadeIn(300);
	},

	backSport: function(e){
		e.preventDefault();

		$acSportList.fadeOut(300, function () {
      html.removeAttribute('style');
			lvl_0[0].classList.add('displayed');
			lvl_0[1].classList.add('displayed');
			lvl_1[0].classList.remove('displayed');
		});
	},

	removeAllSportsToCustomer: function(){

		if(notPracticeSport.checked){
		notPracticeSport.setAttribute("disabled", true);
			// call for delete all sport in session object
		cube.ajax.post(services.DELETE_ALL_SPORT_URL, null)
       .onSuccess(createAccountModule.removeAllSportsToCustomerSuccess)
       .onError(createAccountModule.removeAllSportsToCustomerErrors)
       .call();
		}
	},

  removeAllSportsToCustomerSuccess: function (){

  	//reset user Sport selected
  	var userSportsSelected = cube.$id("user-sports--selected");
  	var userSelectableSports = cube.$class('selectable-sports--sport selected with-basket', userSportsSelected);
  	var i = userSelectableSports.length;
  	while(i--)
  		userSelectableSports[i].remove();

  	//reset Sport selected in sport list component
		var sportListComponent = cube.$id("sportlistcomponent");
		var selectableSports = cube.$class('selectable-sports--sport', sportListComponent);
		i = selectableSports.length;
		while(i--){
			selectableSports[i].classList.remove('selected');
  		selectableSports[i].classList.add('not-selected');
		}

		//reset Sport count in sport list component
		var selectableSportsCategories = cube.$class('selectable-sport-categories--category--status', sportListComponent);
		i = selectableSportsCategories.length;
		while(i--){
			selectableSportsCategories[i].style.display = 'none';
			selectableSportsCategories[i].dataset['sport_count'] = 0;
		}
	},

  removeAllSportsToCustomerErrors: function (){
  	cube.alert.error(Messages("error.removeAllSports"));
	}
};

module.exports = createAccountModule;



// WEBPACK FOOTER //
// ./src/modules-es5/authentication/create-account/create-account-sport.js